import { render } from "./topic.vue?vue&type=template&id=50bac6fe&scoped=true"
import script from "./topic.vue?vue&type=script&lang=js"
export * from "./topic.vue?vue&type=script&lang=js"

import "./topic.vue?vue&type=style&index=0&id=50bac6fe&scoped=true&lang=css"
import "./topic.vue?vue&type=style&index=1&id=50bac6fe&lang=css"
script.render = render
script.__scopeId = "data-v-50bac6fe"

export default script